module.exports = "https://cdn2-fs.clearscore.com/flux/images/8d7ca9f487f7d96b6441b00cc0831b37.jpg";